import { useTranslation } from 'react-i18next';
import yesOrNoImage from 'assets/images/assignments/yes-or-no.svg';
import { Button } from 'components/Button';
import { Heading } from 'components/Typography';

type Props = {
  question: string;
  onAnswer: (answer: boolean) => void;
};

export const TrueOrFalseContent = ({ question, onAnswer }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <img src={yesOrNoImage} alt="True or false" className="max-h-[100px] h-full" />

      <Heading level="h4" useDefaultMargins className="text-center">
        {question}
      </Heading>
      <div className="flex justify-center w-full sm-d:flex-col gap-16">
        <Button size="lg" variant="secondary" className="sm-d:w-full md:min-w-[160px]" onClick={() => onAnswer(true)}>
          {t('learningPath.knowledgeCheck.true')}
        </Button>
        <Button size="lg" variant="secondary" className="sm-d:w-full md:min-w-[160px]" onClick={() => onAnswer(false)}>
          {t('learningPath.knowledgeCheck.false')}
        </Button>
      </div>
    </>
  );
};
